<template>
  <div class="profile_green about-section section-space--inner--80 ">
    <div class="container bg-home--profile">
      <div class="row row-25 pt-4">
        <div class="col-lg-6 col-12 mb-30">
          <div class="about-image-two">
            <img
              v-if="data.image.length > 0"
              :src="data.image"
              class="rounded img-fluid profile_green_image"
              alt="image"
            />
            <img
              v-else
              src="@/assets/images/global/list_empty.png"
              alt="team
          member image"
              class="rounded img-fluid profile_green_image"
            />
            <hr class="span-hr-green-top" />
          </div>
        </div>
        <div class="col-lg-6 col-12 mb-30">
          <div class="about-content-two">
            <h3 class="text-color-green">
              <span class="span-hr-green-left"></span> Tentang Kami
            </h3>
            <h3>{{ data.title }}</h3>
            <div v-html="data.body"></div>
            <!-- <router-link to="#" class="ht-btn--green ht-btn--green--dark-hover btn-pill">
                            Lihat Selengkapnya
                        </router-link> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_profile_2.scss";
</style>
